import React from 'react';
import PropTypes from 'prop-types';

import { ButtonBlueLarge } from '../../Buttons/ButtonBlueLarge/ButtonBlueLarge';
import ButtonBlueOutlineLarge from '../../Buttons/ButtonBlueOutlineLarge/ButtonBlueOutlineLarge';
import ButtonRedOutlineLarge from '../../Buttons/ButtonRedOutlineLarge/ButtonRedOutlineLarge';
import TitleDialog from '../../TitleDialog/TitleDialog';
import Textarea from '../../Textarea/Textarea';

import {
    DIALOG_CONFIRMATION_MOD_VERSION_CANCEL_BUTTON,
    DIALOG_CONFIRMATION_MOD_VERSION_CONTENT,
    DIALOG_CONFIRMATION_MOD_VERSION_OK_BUTTON,
    DIALOG_CONFIRMATION_MOD_VERSION_OK_BUTTON_REJECT,
    DIALOG_CONFIRMATION_MOD_VERSION_TITLE,
    DIALOG_CONFIRMATION_MOD_VERSION_TITLE_REJECT,
} from './translations'

import styles from './DialogConfirmationModVersionRemove.module.css';
import { getUsername, getUserRole } from '../../../utils/functions';

export default class DialogConfirmationModVersionRemove extends React.PureComponent {
    static propTypes = {
        id: PropTypes.number.isRequired,
        isReject: PropTypes.bool,

        type: PropTypes.string,

        onCloseDialog: PropTypes.func.isRequired,
        onSubmitDialog: PropTypes.func.isRequired,
        onRejectMod: PropTypes.func,
    }

    constructor(props) {
        super(props)
    
        this.state = {
          content: '',
          isErrorText: false,
        }
      }

    handleSubmitDialog = () => {
        this.props.isReject ? 
            this.props.onRejectMod( this.props.id, this.state.content, getUsername().spaUsername, getUsername().spaId, getUserRole(), this.props.type ) 
                : this.props.onSubmitDialog( this.props.id )
    }

    handleDescriptionChange = (content) => {
        this.setState({
            content,
            isErrorText: false,
        })
    }

    render() {
        return !this.props.isReject ? (
            <div className={styles.base}>
                <TitleDialog>{DIALOG_CONFIRMATION_MOD_VERSION_TITLE}</TitleDialog>
                <div className={styles.content}>
                    <p>{DIALOG_CONFIRMATION_MOD_VERSION_CONTENT}</p>
                </div>
                <div className={styles.button}>
                    <ButtonBlueLarge onClick={this.props.onCloseDialog}>
                        {DIALOG_CONFIRMATION_MOD_VERSION_CANCEL_BUTTON}
                    </ButtonBlueLarge>
                </div>
                <div className={styles.button}>
                    <ButtonBlueOutlineLarge onClick={this.handleSubmitDialog}>
                        {DIALOG_CONFIRMATION_MOD_VERSION_OK_BUTTON}
                    </ButtonBlueOutlineLarge>
                </div>
            </div>
        ) : (
            <div className={styles.base}>
                <TitleDialog>{DIALOG_CONFIRMATION_MOD_VERSION_TITLE_REJECT}</TitleDialog>
                <div className={styles.content}>
                    <p>Информация для мододела:</p>
                    <Textarea 
                        isError={this.state.isErrorText}
                        value={this.state.content}
                        onChange={this.handleDescriptionChange} 
                    />
                </div>
                <div className={styles.button}>
                    <ButtonBlueLarge onClick={this.props.onCloseDialog}>
                        {DIALOG_CONFIRMATION_MOD_VERSION_CANCEL_BUTTON}
                    </ButtonBlueLarge>
                </div>
                <div className={styles.button}>
                    <ButtonRedOutlineLarge onClick={this.handleSubmitDialog}>
                        {DIALOG_CONFIRMATION_MOD_VERSION_OK_BUTTON_REJECT}
                    </ButtonRedOutlineLarge>
                </div>
            </div>
        )
    }
}
